import { hasLocalStorageTimestamp } from "@utils/bonusCard";
import { BonusCardStatus, StorageKeys } from "@utils/enums";

type BonusCardState = {
    email: string;
    timeStamp: string;
};

type BonusCardStates = Array<BonusCardState>;

export const getBonusCardRequestedState = (): BonusCardStates | undefined => {
    const item = localStorage.getItem(StorageKeys.BonusCardRequested);

    if (!item) {
        return undefined;
    }

    let parsedItem;

    try {
        parsedItem = JSON.parse(item);
    } catch {
        parsedItem = undefined;
    }

    if (!parsedItem) {
        return undefined;
    }

    return parsedItem as BonusCardStates;
};

const setState = (newState: BonusCardStates) => {
    localStorage.setItem(
        StorageKeys.BonusCardRequested,
        JSON.stringify(newState),
    );
};

export const setBonusCardRequestedState = (email: string) => {
    try {
        const state = getBonusCardRequestedState();
        setState([
            ...(state || []),
            {
                email,
                timeStamp: new Date().getTime().toString(),
            },
        ]);
    } catch (err) {
        console.error(err);
    }
};

export const removeBonusCardRequestedState = (email: string) => {
    try {
        const state = getBonusCardRequestedState();
        if (!state) {
            return;
        }
        const newState = state.filter(s => s.email !== email);
        setState([...newState]);
    } catch (err) {
        console.error(err);
    }
};

export const getStatus = (customer: {
    bonusCardNumber?: null | string;
    eBonusCardNumber?: null | string;
    bonusCardRequested?: null | boolean;
    email: string;
}) => {
    if (customer.bonusCardNumber || customer.eBonusCardNumber) {
        return BonusCardStatus.HasCard;
    }

    if (customer?.bonusCardRequested && !customer.bonusCardNumber) {
        return BonusCardStatus.CardOnRoute;
    }

    if (
        customer &&
        hasLocalStorageTimestamp(customer.email) &&
        !customer.bonusCardRequested
    ) {
        return BonusCardStatus.Requested;
    }

    return BonusCardStatus.NoCard;
};
